import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class Configuration {
  get isProduction() {
    return environment.production;
  }
  get iManageApi() {
    return environment.iManageApi;
  }
  get eraServer() {
    return environment.eraServer;
  }
  get iManageWeb() {
    return environment.iManageWeb;
  }
  get iBudget() {
    return environment.iBudget;
  }
  get proConnectWeb() {
    return environment.proConnectUrl;
  }
  get peopleSearchWeb() {
    return environment.peopleSearchUrl;
  }
  get iShareServer() {
    return environment.iShareUrl;
  }
  get accountsUrl() {
    return environment.accountsUrl;
  }
  get opportunitiesUrl() {
    return environment.opportunitiesUrl;
  }
  get hubUrl() {
    return environment.hubUrl;
  }
  get pmToolboxUrl() {
    return environment.pmToolboxUrl;
  }
  get validurl() {
    return environment.validUrl;
  }
  get validlightningurl() {
    return environment.validLightningUrl;
  }
  get sessionTimeoutInSeconds() {
    return environment.sessionTimeoutInSeconds;
  }
  get timeoutWarningInSeconds() {
    return environment.timeoutWarningInSeconds;
  }
  get teamsUrl() {
    return environment.teamsUrl;
  }
  get pkicViewRequestsUrl() {
    return environment.pkicViewRequestsUrl;
  }
  get pkicIShareSite() {
    return environment.pkicIShareSite;
  }
  get drbHomeTileUrl() {
    return environment.drbHomeTileUrl;
  }
  get winStrategyUrl() {
    return environment.winStrategyUrl;
  }
  get drbUrl() {
    return environment.drbUrl;
  }
  get genericContactKey() {
    return environment.GenericContact;
  }
  get relatedContacts() {
    return environment.relatedContacts;
  }
  get clientVaccincationFormUrl() {
    return environment.clientVaccincationFormUrl;
  }
  get sfdcRecordType() {
    return environment.sfdcRecordType;
  }
  get pursuitCandidateHistoryUrl() {
    return environment.pursuitCandidateHistoryUrl;
  }
  get iAccessURL() {
    return environment.iAccessURL;
  }
  get allowedIAccessEmployees() {
    const businessUnits: number[] =
      environment.allowedIAccessEmployeesBusinessUnits.map((x: string) => Number(x));
    return businessUnits;
  }
  get appInsightsInstrumentationKey() {
    return environment.appInsights.instrumentationKey;
  }
  get engagementResourceRequestsUrl(){
    return environment.engagementResourceRequestUrl;
  }

  // get proGPTplusURL() {
  //   return environment.proGPTplusURL;
  // }

  // get reactAppEngagementAcceleratorId() {
  //   return environment.reactAppEngagementAcceleratorId;
  // }

  fileNameCharactersRestrictions: string[] = [
    '"',
    '*',
    ':',
    '<',
    '>',
    '?',
    '/',
    '\\',
    '|',
  ];
  fileNameInvalidFullNameRestriction: string[] = ['desktop.ini'];
  fileNameInvalidNameRestriction: string[] = [
    'con',
    'prn',
    'aux',
    'nul',
    'com1',
    'com2',
    'com3',
    'com4',
    'com5',
    'com6',
    'com7',
    'com8',
    'com9',
    'lpt1',
    'lpt2',
    'lpt3',
    'lpt4',
    'lpt5',
    'lpt6',
    'lpt7',
    'lpt8',
    'lpt9',
    '_vti_',
  ];
  fileNameFileTypeRestrictions: string[] = [
    'exe',
    'bat',
    'js',
    'vbs',
    'asp',
    'html',
    'wsf',
    'wsh',
    'sql',
    'sh',
    'ps1',
  ];

  get documentNameCharacterRestrictions(): string[] {
    return [...this.fileNameCharactersRestrictions, ';', '#'];
  }

  get documentNameInvalidNameRestrictions(): string[] {
    return [
      ...this.fileNameInvalidNameRestriction,
      ...this.fileNameInvalidFullNameRestriction,
    ];
  }

  ironcladSupportedFileExtensions: string[] = [
    'doc', 'docx', 'pdf', 'xls', 'xlsm', 'xlsx', 'eml', 'tif', 'jpg', 'png', 'jpeg',
    'txt', 'ppt', 'pptx', 'msg', 'csv', 'gif', 'htm', 'rtf', 'wml', 'asice', 'adoc',
    'bdoc', 'ddoc', 'edoc'
  ];

  uploadExplicitlyBlockedFileExtensions: string[] = [
    'exe', 'bat', 'js', 'emltpl', 'log', 'oft', 'p7m', 'tiff', 'xltx', 'zip'
  ];

  uploadScriptFileExtensions: string[] = [
    'ps1', 'sh', 'bash', 'ksh', 'csh', 'zsh', 'vbs', 'vbe', 'wsf', 'wsh',
    'cmd', 'com', 'py', 'rb', 'pl', 'php', 'mjs', 'cjs', 'ts', 'tsx', 'jsx'
  ];

  fileRestrictionCheck(file: File, limitNumber: number): string {
    let characterRestricted = false;
    let nameRestricted = false;
    let fileTypeRestricted = false;
    let fileSizeRestricted = false;

    if (file.size >= 109999999 || file.size <= 0) {
      fileSizeRestricted = true;
    }
    for (var i = 0; i < this.fileNameCharactersRestrictions.length; i++) {
      if (file.name.indexOf(this.fileNameCharactersRestrictions[i]) > -1) {
        characterRestricted = true;
        break;
      }
    }
    let index = file.name.lastIndexOf('.');
    let fileName = index < 0 ? file.name : file.name.substring(0, index);
    if (
      file.name.startsWith('~$') ||
      this.fileNameInvalidNameRestriction.some(
        (x) => x === fileName.toLowerCase(),
      ) ||
      this.fileNameInvalidFullNameRestriction.some(
        (x) => x === file.name.toLowerCase(),
      )
    ) {
      nameRestricted = true;
    }
    for (var i = 0; i < this.fileNameFileTypeRestrictions.length; i++) {
      if (
        file.name
          .toLowerCase()
          .split('.')
          [
            file.name.split('.').length - 1
          ].indexOf(this.fileNameFileTypeRestrictions[i].toLowerCase()) === 0
      ) {
        fileTypeRestricted = true;
        break;
      }
    }

    let fileNumberRestricted = limitNumber == 4 ? true : false;

    if (!characterRestricted && !nameRestricted &&
      !fileTypeRestricted && !fileSizeRestricted &&
      !fileNumberRestricted) {
      //0000
      return '';
    } else if (
      !characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //0010
      return 'The following file types cannot be attached: .exe, .bat, .js, or any script file.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      !fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //0100
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //0110
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      !fileTypeRestricted &&
      !fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1000
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1010
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      !fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1100
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1110
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.';
    } else if (
      !characterRestricted &&
      !nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //0001/////////////////////////////////////////////////////////////
      return 'File size must be between 1KB-100MB.';
    } else if (
      !characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //0011
      return 'The following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //0101
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nFile size must be between 1KB-100MB.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //0111
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 -  LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1001
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nFile size must be between 1KB-100MB.';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1011
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1101
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nFile size must be between 1KB-100MB.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      !fileNumberRestricted
    ) {
      //1111
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.';
    } else if (
      !characterRestricted &&
      !nameRestricted &&
      !fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0000
      return 'Only a maximum of four files can be uploaded.';
    } else if (
      !characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0010
      return 'The following file types cannot be attached: .exe, .bat, .js, or any script file.\nOnly a maximum of four files can be uploaded.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0100
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nOnly a maximum of four files can be uploaded.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0110
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      !fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1000
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1010
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1100
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      !fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1110
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nOnly a maximum of four files can be uploaded.';
    } else if (
      !characterRestricted &&
      !nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0001/////////////////////////////////////////////////////////////
      return 'File size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    } else if (
      !characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0011
      return 'The following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0101
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nFile size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    } else if (
      !characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //0111
      return 'The following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 -  LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1001
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nFile size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      !nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1011
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      !fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1101
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nFile size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    } else if (
      characterRestricted &&
      nameRestricted &&
      fileTypeRestricted &&
      fileSizeRestricted &&
      fileNumberRestricted
    ) {
      //1111
      return 'A file name cannot contain any of the following characters: " * : < > ? /  | , .\nThe following file names are invalid: .lock, CON, PRN, AUX, NUL, COM1 - COM9, LPT1 - LPT9, _vti_, desktop.ini, any filename starting with ~$.\nThe following file types cannot be attached: .exe, .bat, .js, or any script file.\nFile size must be between 1KB-100MB.\nOnly a maximum of four files can be uploaded.';
    }
    return '';
  }
}
